module.exports = __webpack_public_path__ + "img/operating-platform.3419e10e.png";